import React, { createContext, useEffect, useState } from "react";
import LoadingScreen from "../../../components/loadingScreen/LoadingScreen";
import { auth } from "../../firebaseConfig";

export const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    return auth.onAuthStateChanged(async (user) => {
      if (user?.uid) {
        user
          .getIdTokenResult()
          .then((idTokenResult) => {
            setUser(idTokenResult.claims);
            setLoading(false);
          })
          .catch((error) => {
            console.log("Error getting document:", error);
          });
      } else {
        setUser(null);
        setLoading(false);
      }
    });
  }, []);

  if (loading) {
    return (
      <div>
        <LoadingScreen />
      </div>
    );
  } else {
    return <AuthContext.Provider value={user}>{children}</AuthContext.Provider>;
  }
};
